import type { ProductConfig } from '../../default/product/product.types';
import type { DeepPartial } from '../../default/types';

export const productConfig: DeepPartial<ProductConfig> = {
  cliplister: {
    customerId: '86453',
  },
  powerSupply: {
    pictogram: {
      included: 'https://bilder.universal.at/i/empiriecom/FuAG_included.svg',
      notIncluded: 'https://bilder.universal.at/i/empiriecom/FuAG_not_included.svg',
      specification: 'https://bilder.universal.at/i/empiriecom/FuAG_specifications.svg',
    },
  },
  ecoFriendlyDelivery: {
    enabled: true,
  },
};
